import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-cash-flow-fli',
  templateUrl: './delete-cash-flow-fli.component.html',
  styleUrls: ['./delete-cash-flow-fli.component.scss']
})
export class DeleteCashFlowFliComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
